import React, { useEffect } from "react";
import "./ScrollImg.css";

import c1 from "../../Assets/project16/c1.webp";
import c2 from "../../Assets/project16/c2.webp";
import c3 from "../../Assets/project16/c3.webp";
import c4 from "../../Assets/project16/c4.webp";
import c5 from "../../Assets/project16/c5.webp";
import c6 from "../../Assets/project16/c6.webp";
import c7 from "../../Assets/project16/c7.webp";
import c8 from "../../Assets/project16/c8.webp";
import c9 from "../../Assets/project16/c9.webp";
import c10 from "../../Assets/project16/c10.webp";
import c11 from "../../Assets/project16/c11.webp";
import c12 from "../../Assets/project16/c12.webp";
import c13 from "../../Assets/project16/c13.webp";
import c14 from "../../Assets/project16/c14.webp";


const ScrollImg16 = () => {
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".section");
      const scroll = window.scrollY + window.innerHeight / 3;

      let isActiveSectionFound = false;

      sections.forEach((section) => {
        const top = section.offsetTop;
        const height = section.offsetHeight;

        if (top <= scroll && top + height > scroll) {
          sections.forEach((s) => s.classList.remove("active"));
          section.classList.add("active");
          isActiveSectionFound = true;
        }
      });

      // If no section is in view, ensure all are inactive
      if (!isActiveSectionFound) {
        sections.forEach((s) => s.classList.remove("active"));
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Trigger the scroll effect initially
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const images = [c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11, c12, c13, c14];


  return (
    <div>
      {images.map((image, index) => (
        <div key={index} className="section">
          <div className="section-img">
            <div
              className="section-img-inner"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScrollImg16;
